import { useDispatch, useSelector } from "react-redux";
import { downloadPaymentsReportExcel } from "../thunks/downloadPaymentsReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const usePaymentsExcelReportDownloader = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.reports.exchbusiness.clientOverview.fetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => dispatch(downloadPaymentsReportExcel()), [dispatch]);

	return [download, fetchState] as [typeof download, typeof fetchState];
};
